import getIn from 'transmute/getIn';
export const getResponders = getIn(['responders']);